export const isSearchingWithinGroup = (formid) =>
  formid === 'group_member_search_members';
